
<script>
	import pagination from "laravel-vue-pagination";
	import { driverService } from '../../../services';
	import { get_currency } from '../../../Helper/helper';

	export default {
		components: { driverService, get_currency, pagination },
		data() {
			return {
				fields: [
					{ label: "#", key: "driver_earning_id", sortable: false },
					{ key: 'order_id',label: this.trans.get('__JSON__.Order Id'), sortable: true },
					{ key: 'type',label: this.trans.get('__JSON__.Type'), sortable: true },
					{ key: 'amount',label: this.trans.get('__JSON__.Amount'), sortable: true },
					{ key: 'restaurant_id',label: this.trans.get('__JSON__.Restaurant Name'), sortable: true },
					{ key: 'redeemed_date',label: this.trans.get('__JSON__.Redeemed Date'), sortable: true },
					{ key: 'created_at',label: this.trans.get('__JSON__.Created At'), sortable: true },
					{ key: 'action',label: this.trans.get('__JSON__.Action'), sortable: false },
            	],
				earnings: [],
				currency: get_currency(),
				total_earning: 0,
				driverEaringLoaded: false,
				paginations: {},
				limit: 1,
				loading: false,
				sortBy: "created_at", // Default sorting
				sortDesc: true,
				page: 1
			}
		},

		mounted() {
			this.getDriverEarnings();
		},
		methods: {
			getDriverEarnings(page) 
			{
				this.loading = true;
				driverService.getDriverEarnings({
					sortBy: this.sortBy,
					orderBy: this.sortDesc ? 'desc':'asc',
					page: page ? page : 1,
					driver_id: this.$route.params.driver_id, // get id from route
					vendor_id : this.$auth.user.vendor_id,
				})
				.then(response => {
					this.loading = false;
					this.earnings = response.data.result.Result.driver_earnings;
					this.total_earning = response.data.result.Result.total_earning;
					this.paginations = response.data.result.Result.pagination;
				}).catch(error => {
					console.error(error);
					this.loading = false;
				});
			},

			redeemedEarnings(total_earning) {
				this.$swal({
					title: this.trans.get('__JSON__.Are you sure?'),
					text: this.trans.get('__JSON__.You want to redeem this earning?'),
					icon: 'warning', // Use 'icon' instead of 'type'
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: this.trans.get('__JSON__.Yes'),
					cancelButtonText: this.trans.get('__JSON__.No'),
				}).then((result) => {
					console.log(result.isConfirmed);
					
					if (result.isConfirmed) { // Check if the user confirmed the action
						driverService.redeemedEarnings({
							driver_id: this.$route.params.driver_id,
							total_earning: total_earning
						})
						.then(response => {
							console.log(response);
							this.$swal(
								this.trans.get('__JSON__.Redeemed!'),
								this.trans.get('__JSON__.Earnings have been redeemed successfully.'),
								'success'
							);

							this.getDriverEarnings();
						})
						.catch(error => {
							console.error(error);
							this.$swal(
								this.trans.get('__JSON__.Error!'),
								this.trans.get('__JSON__.There was an issue redeeming the earnings.'),
								'error'
							);
						});
					}
				});
			},
			sortingEarning(ctx){
				this.sortBy = ctx.sortBy;
				this.sortDesc = ctx.sortDesc;
				this.getDriverEarnings();
        	},
			deleteEarnings(earning_id)
			{
				this.$swal({
					title: this.trans.get('__JSON__.Are you sure?'),
					text: this.trans.get('__JSON__.You want to delete this earning?'),
					icon: 'warning', // Use 'icon' instead of 'type'
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: this.trans.get('__JSON__.Yes'),
					cancelButtonText: this.trans.get('__JSON__.No'),
				}).then((result) => {
					console.log(result.isConfirmed);
					
					if (result.isConfirmed) {	
						driverService.deleteEarnings({
							driver_id: this.$route.params.driver_id,
							earning_id: earning_id
						})
						.then(response => {
							if(response.data.code == 200)
							{
								this.$swal(
									this.trans.get('__JSON__.Deleted'),
									this.trans.get('__JSON__.' + response.data.message),
									'success'
								);

								this.getDriverEarnings();
							}
							else
							{
								this.$swal(
									this.trans.get('__JSON__.Error!'),
									this.trans.get('__JSON__.' + response.data.message),
									'error'
								)
							}

						})
						.catch(error => {
							console.error(error);
							this.$swal(
								this.trans.get('__JSON__.Error!'),
								this.trans.get('__JSON__. '+ response.data.message),
								'error'
							);
						});
					}
				});
			}
		}
	};
</script>
<template>
	<div class="row">
		<div class="col-12">
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col-md-6">
							<span class="font-weight-bold font-size-16">{{trans.get('__JSON__.Total Earning')}} : 
								<span v-html="currency"></span>
								{{ parseFloat(total_earning || 0).toFixed(2) }}
							</span>
						</div>
						<div class="col-md-6">
							<v-button class="btn btn-warning float-right" v-if="total_earning > 0" @click.prevent="redeemedEarnings(total_earning)">
								{{trans.get('__JSON__.Redeem')}}
							</v-button>
						</div>
						
					</div>
					<div class="col-12 table-main-list">
						<b-table
							:items="earnings"
							:fields="fields"
							:busy="loading"
							:sort-by.sync="sortBy"
							:no-local-sorting="true"
							show-empty
                        	@sort-changed="sortingEarning"
							>
							<template #empty>
								<p class="text-center">{{ trans.get("__JSON__.No Earning Found") }}</p>
							</template>
							<template #table-busy>
								<div class="text-center text-danger my-2">
									<b-spinner class="align-middle"></b-spinner>
									<strong>{{ trans.get("__JSON__.Loading...") }}</strong>
								</div>
							</template>
							<template v-slot:cell(driver_earning_id)="data">
								<span>{{ data.index + 1 + ((paginations.current_page-1) * paginations.per_page)  }}</span>
							</template>
							<template v-slot:cell(order_id)="data">
								<span v-if="data.item && data.item.type == '2'"> {{ data.item.redeemed_id ? 'Redeemed #' + data.item.redeemed_id : '-' }} </span>
								<span v-else>{{ data.value && data.value != 0 ? 'Order #' + data.value : '-' }}</span>
							</template>
							<template v-slot:cell(type)="data">
								<span class="badge badge-pill font-size-12"
                    					:class="{'badge-soft-danger':(['1'].includes(data.value)),'badge-soft-success':(data.value == '0'),'badge-soft-info':(data.value == '2'), 'badge-soft-warning':(data.value == '3')}"
									>
									{{ data.value == '0' ? 'Incentive' : 
										(data.value == '1' ? 'Penalty' : 
											(data.value == '2' ? 'Redeemed' : 
												(data.value == '3' ? 'Base Incentive' : '')
											)
										) }}
								</span>
							</template>
							<template v-slot:cell(amount)="data">
								<span v-html="currency"></span>
								{{ data.value ? parseFloat(data.value).toFixed(2) : '0.00' }}
							</template>
							<template v-slot:cell(restaurant_id)="data">
								{{ data.value ? data.value : '-' }}
							</template>
							<template v-slot:cell(redeemed_date)="data">
								{{ data.value ? data.value : '-' }}
							</template>
							<template v-slot:cell(action)="data">
								<button type="submit"
									v-if="!$auth.partner_login && data.item && data.item.type && ['0','1'].includes(data.item.type)"
									class="btn btn-danger btn-sm btn-rounded ml-1"
									@click="deleteEarnings(base64(data.item.driver_earning_id))"
								>{{ trans.get('__JSON__.Delete') }}</button>
							</template>
						</b-table>  
					</div>
					<div class="row col-sm-5 offset-sm-7">
						<div class="col">
							<div class="dataTables_paginate paging_simple_numbers float-right">
								<ul class="pagination pagination-rounded mb-0">
								<pagination :data="paginations" :limit="limit" @pagination-change-page="getDriverEarnings"></pagination>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

